import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    buttons: {
      display: 'flex',
      justifyContent: 'space-between',
      width: '-webkit-fill-available'
    },
    gap: { display: 'flex', flexDirection: 'column', gap: '20px' },
    headintro: {
      display: 'flex',
      gap: '5px',
      flexWrap: 'wrap',
      fontWeight: 600,
      fontSize: '1.5rem'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
